import Commons from '../../../../Services/Common/Common';

/**
 * 그리드 필드: AUTH_CD, PRO_ID, PRO_CONTENT, PRO_DTL, PRO_DTL_NM, SAVE_YN, DELETE_YN, PRINT_YN
 * API 본문: PascalCase + 암호화
 */
export const AUT_BASIC_Schema = {
  fields: {
    PRO_ID: { initial: '', label: '프로그램ID', required: 'Y' },
    PRO_DTL: { initial: '', label: '메뉴 상세코드', required: 'Y' },
    PRO_DTL_NM: { initial: '', label: '프로그램 상세' },
    SAVE_YN: { initial: 'N', label: '추가,저장 권한' },
    DELETE_YN: { initial: 'N', label: '삭제 권한' },
    PRINT_YN: { initial: 'N', label: '출력 권한' },
  },
  mapper: {
    search1: {
      AuthCd: (_, ctx) =>
        Commons.EncryptAES(String(ctx.authCd ?? '').trim()) || '',
      Params: (_, ctx) =>
        Commons.EncryptAES(String(ctx.params ?? '').trim()) || '',
    },
    search2: {
      Params: (_, ctx) =>
        Commons.EncryptAES(String(ctx.params ?? '').trim()) || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      ProId: (row) =>
        Commons.EncryptAES(row.PRO_ID ?? row.proId ?? '') || '',
      ProDtl: (row) =>
        Commons.EncryptAES(row.PRO_DTL ?? row.proDtl ?? '') || '',
      ProDtlNm: (row) =>
        Commons.EncryptAES(row.PRO_DTL_NM ?? row.proDtlNm ?? '') || '',
      SaveYn: (row) =>
        Commons.EncryptAES(row.SAVE_YN ?? row.saveYn ?? '') || '',
      DeleteYn: (row) =>
        Commons.EncryptAES(row.DELETE_YN ?? row.deleteYn ?? '') || '',
      PrintYn: (row) =>
        Commons.EncryptAES(row.PRINT_YN ?? row.printYn ?? '') || '',
      AuthCd: (row, context) =>
        Commons.EncryptAES(
          String(
            row.AUTH_CD ??
              row.authCd ??
              context.authCd ??
              ''
          ).trim()
        ) || '',
    },
    delete1: {
      ProId: (row) =>
        Commons.EncryptAES(row.PRO_ID ?? row.proId ?? '') || '',
      ProDtl: (row) =>
        Commons.EncryptAES(row.PRO_DTL ?? row.proDtl ?? '') || '',
      AuthCd: (row, context) =>
        Commons.EncryptAES(
          String(
            row.AUTH_CD ??
              row.authCd ??
              context.authCd ??
              ''
          ).trim()
        ) || '',
    },
  },
};
